import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Button,
  Divider,
  ListItemButton,
  Alert,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { AppDownloadDialog } from "./AppDownloadDialog";

export const AddToHomeScreenANdroid = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null);
  const [appDownloadDialogIsOn, setAppDownloadDialogIsOn] =
    useState<boolean>(false);
  const [isInstalled, setIsInstalled] = useState<boolean>(false);
  const navigate = useNavigate();

  // PWAのインストール状態を確認
  useEffect(() => {
    // インストール済みかどうかを確認
    const checkInstallStatus = () => {
      const isStandalone =
        window.matchMedia("(display-mode: standalone)").matches ||
        (window.navigator as any).standalone === true ||
        document.referrer.includes("android-app://");
      setIsInstalled(isStandalone);
    };

    checkInstallStatus();

    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstalled(false); // プロンプトが表示される = まだインストールされていない
    };

    // アプリがインストールされた時のイベント
    const handleAppInstalled = (e: any) => {
      console.log("PWA was installed");
      setIsInstalled(true);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleInstallClick = () => {
    console.log(deferredPrompt);
    if (deferredPrompt) {
      (deferredPrompt as any).prompt();
      (deferredPrompt as any).userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
          setIsInstalled(true);
        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
        setAppDownloadDialogIsOn(false);
      });
    }
  };

  // インストール状況に応じた表示内容
  const renderContent = () => {
    if (isInstalled) {
      return (
        <>
          <Alert severity="success" sx={{ mb: 2 }}>
            ✅ このアプリは既にインストールされています
          </Alert>
          <Card sx={{ mt: 2, p: 2, backgroundColor: "#f5f5f5" }}>
            <Typography variant="h6" gutterBottom>
              アンインストール方法
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="1. ホーム画面でアプリアイコンを長押し" />
              </ListItem>
              <ListItem>
                <ListItemText primary="2. 「アンインストール」または「削除」をタップ" />
              </ListItem>
              <ListItem>
                <ListItemText primary="3. 確認ダイアログで「OK」をタップ" />
              </ListItem>
            </List>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              ※ または設定 → アプリ → アプリ名 → アンインストール
            </Typography>
          </Card>
        </>
      );
    }

    if (!deferredPrompt) {
      return (
        <>
          <Alert severity="info" sx={{ mb: 2 }}>
            インストールプロンプトが利用できません。手動でインストールしてください。
          </Alert>
          <Card sx={{ mt: 2, p: 2, backgroundColor: "#e3f2fd" }}>
            <Typography variant="h6" gutterBottom>
              手動インストール方法
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="1. Chromeのメニュー（⋮）をタップ" />
              </ListItem>
              <ListItem>
                <ListItemText primary="2. 「ホーム画面に追加」または「アプリをインストール」を選択" />
              </ListItem>
              <ListItem>
                <ListItemText primary="3. 「追加」をタップ" />
              </ListItem>
            </List>
          </Card>
        </>
      );
    }

    return (
      <List>
        <ListItem>
          <ListItemText primary="1. Chromeでこのページを開きます" />
        </ListItem>
        <ListItem>
          <ListItemText primary="2.以下の「ダウンロード」ボタンをタップします" />
        </ListItem>
        <ListItem>
          <Button
            onClick={() => setAppDownloadDialogIsOn(true)}
            variant="contained"
          >
            ダウンロード
          </Button>
        </ListItem>
        <ListItem>
          <ListItemText primary="3. 案内に従ってインストールを完了してください" />
        </ListItem>
      </List>
    );
  };

  return (
    <>
      <Box sx={{ p: 1 }}>
        <Button onClick={() => navigate("/")}>
          <ArrowBackIosIcon fontSize="small" />
          戻る
        </Button>
      </Box>
      <Divider />
      <Card
        sx={{
          maxWidth: 600,
          margin: "auto",
          mt: 2,
          mx: 1,
          p: 1,
          borderRadius: 4,
          boxShadow: 3,
        }}
      >
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Android端末でのアプリ管理
          </Typography>
          <Typography variant="body1" gutterBottom>
            Android端末をご利用の場合は、以下をご確認ください。
          </Typography>

          {renderContent()}

          <Typography variant="body2" color="text.secondary" mt={2}>
            ※ 表示されない場合は Chrome
            のバージョンが古い可能性があります。最新バージョンをご確認ください。
          </Typography>
        </CardContent>
      </Card>
      <AppDownloadDialog
        isOn={appDownloadDialogIsOn}
        setIsOn={setAppDownloadDialogIsOn}
        handleInstallClick={handleInstallClick}
      />
    </>
  );
};
